/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThresholdAlertUpdateRequest {
    getFixupPrototypeFunction() { return ThresholdAlertUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<ThresholdAlertUpdateRequest>): ThresholdAlertUpdateRequest {
        let obj = Object.assign(new ThresholdAlertUpdateRequest(), model);
        ThresholdAlertUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThresholdAlertUpdateRequest>): ThresholdAlertUpdateRequest {
        if (!model) return null;
        return ThresholdAlertUpdateRequest.newInstance(<ThresholdAlertUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThresholdAlertUpdateRequest) {
        if (!obj) return;

        models.ThresholdAlertUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThresholdAlertUpdateRequest): boolean {
        Object.setPrototypeOf(obj, ThresholdAlertUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.threshold_details) {
            for (let val of this.threshold_details) {
                models.ThresholdDetailsModel.fixupPrototype(val);
            }
        }
    }

    /**
     * budget uri
     */
    budget_uri: string;

    /**
     * Threshold Details
     */
    threshold_details: Array<models.ThresholdDetailsModel>;

}
